import { IJackpotWin } from '@GFTypes/GameStoreTypes/WinLevels';

export const JACKPOT_WIN_CONFIGURATION_DEFAULTS: IJackpotWin[] = [];
